document.addEventListener('DOMContentLoaded', () => {
    const logo = document.querySelector('.site-header__logo');
    logo.style.opacity = '0';
      logo.style.transform = 'scale(0)';
      logo.animate([
          { opacity: 0, transform: 'scale(0)' },
          { opacity: 1, transform: 'scale(1)' }
        ], {
        duration: 600,
        easing: 'ease-out',
        fill: 'both'
      });
});